module.exports = __webpack_public_path__ + "static/media/emotions-alt.ad8cf15e.svg";